import React from 'react'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import Typography from '@material-ui/core/Typography'

export const ADD_ON_BILLING_QUESTION = 'Allow my add-ons to be billed on my subscription?'

/**
 * The primary's family-wide answer, asked in the renewal popup before signing
 * (add-on renewal spec, section 2). Only primaries eligible for add-ons see it.
 * Unchecked unless the caller passes a stored Yes.
 */
const AddOnBillingQuestion = ({ eligible, checked = false, disabled = false, onChange }) => {
    if (!eligible) {
        return null
    }

    return <div>
        <FormControlLabel
            control={
                <Checkbox
                    checked={!!checked}
                    disabled={disabled}
                    onChange={(e) => onChange(e.target.checked)}
                    name="paysForAddOns"
                    color="primary"
                />
            }
            label={ADD_ON_BILLING_QUESTION}
        />
        <Typography variant="body2" color="textSecondary">
            If you leave this unchecked, your add-on members can still pay for their own plans.
        </Typography>
    </div>
}

export default AddOnBillingQuestion
